import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-bus-overview-student-table",
	templateUrl: "./bus-overview-student-table.component.html",
	styleUrls: ["./bus-overview-student-table.component.css"],
})
export class BusOverviewStudentTableComponent implements OnInit {
	constructor() {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() lstStudents: any = [];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPerson: any;

	//Filter lists
	lstSchoolFullName: any = [];
	lstisScheduledRiderDesc: any = [];
	lstScanTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "isScheduledRiderDesc", header: "Scheduled Rider" },
		{ field: "GotOnDTDesc", header: "Got On Bus" },
		{ field: "ScanTypeDesc", header: "Scan Type" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	UpdateData() {
		this.lstSchoolFullName = Array.from(new Set(this.lstStudents.map((item: any) => item.SchoolFullName))).sort();
		this.lstisScheduledRiderDesc = Array.from(new Set(this.lstStudents.map((item: any) => item.isScheduledRiderDesc))).sort();
		this.lstScanTypeDesc = Array.from(new Set(this.lstStudents.map((item: any) => item.ScanTypeDesc))).sort();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		this.SelectedPerson = Person;
	}
	////////////////////////////////////////////
}
